export default __webpack_public_path__ + "static/img-4-0fc2d2553ab8519972e68e542f0fae4f.png";